<template>
    <footer class="footer">
        <v-container>
            <v-row class="row--small">
                <v-col>
                    <h1 class="font-size-20 font-size-lg-32 line-height-14 ma-0">KATA Auction</h1>
                    <div class="mt-20 mt-md-30">
                        <ul class="footer-link">
                            <li><router-link to="/location">LOCATION </router-link></li>
                            <li><router-link to="/auction-policy">경매약관</router-link></li>
                            <li><router-link to="/service-policy">서비스이용약관</router-link></li>
                            <li><router-link to="/privacy-policy">개인정보처리방침</router-link></li>
                        </ul>
                    </div>
                    <div class="mt-16">
                        <ul class="footer-info">
                            <li v-for="item in info" :key="item._id">
                                <span>{{ item.term }}</span> {{ item.desc }}
                            </li>
                            <!-- <li><span>대표이사</span>황규성</li>
                            <li><span>사업자등록번호</span>110-06-43555</li>
                            <li><span>통신판매업신고번호</span></li>
                            <li><span>주소</span>서울특별시 종로구 자하문로41길 4</li>
                            <li><span>대표전화</span>02-395-6987</li> -->
                        </ul>
                    </div>
                    <div class="mt-10">
                        <p class="copyright">Copyright ⓒ KATA Auction. All Rights Rerserved</p>
                    </div>
                </v-col>
                <v-col cols="12" md="auto" order="first" order-md="last" class="d-flex flex-md-column">
                    <!-- <v-select large hide-details outlined placeholder="Family Site" append-icon="mdi-chevron-down" class="familysite"
                    :items="sites" item-text="name" item-value="link" v-model="site" @change="changeD">
                    </v-select> -->
                    <v-row class="row--x-small" align="center" align-md="start">
                        <v-col cols="auto"><span class="d-inlie-block font-size-14 font-weight-medium mr-8">SNS</span></v-col>
                        <v-col v-for="{ _id, href, type } in sns" :key="_id" cols="auto">
                            <v-btn width="24" height="24" icon text class="justify-center align-center line-height-0 mr-4" target="_blank" v-bind="{ href }">
                                <img v-if="type == 'twitter'" src="/images/icon/icon-twitter.png" alt="트위터" />
                                <img v-if="type == 'facebook'" src="/images/icon/icon-facebook.png" alt="페이스북" />
                                <img v-if="type == 'instagram'" src="/images/icon/icon-insta.png" alt="인스타" />
                            </v-btn>
                        </v-col>
                    </v-row>
                    <u-scroll-top class="mt-md-auto ml-md-auto"></u-scroll-top>
                </v-col>
                <!-- <v-col cols="12" md="auto" class="d-flex">
                    <u-scroll-top class="mt-auto ml-auto"></u-scroll-top>
                </v-col> -->
            </v-row>
        </v-container>
    </footer>
</template>

<script>
import UScrollTop from "@/components/dumb/u-scroll-top.vue";
import api from "@/api";

export default {
    components: {
        UScrollTop,
    },
    data() {
        return {
            setting: null,
        };
    },
    computed: {
        info() {
            return this.setting?.footer?.info || [];
        },
        sns() {
            return (this.setting?.footer?.sns || []).filter(({ shows }) => shows);
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            const { setting } = await api.v1.setting.get();
            this.setting = setting;
        },
    },
};
</script>

<style scoped>
.footer {
    color: #959595;
    background-color: #151515;
    padding: 40px 0;
}
.footer .container {
    max-width: calc(var(--container-lg) + 24px);
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .footer {
        padding: 60px 0;
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
.footer-link {
    display: flex;
    flex-wrap: wrap;
    margin: -4px -10px;
}
.footer-link li {
    position: relative;
    padding: 4px 10px;
}
.footer-link li::before {
    display: none;
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
    width: 1px;
    height: 8px;
    background-color: #959595;
}
.footer-link li:first-child::before {
    display: none;
}
.footer-link li a {
    display: block;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.2;
    color: #959595;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .footer-link {
        margin: 0 -14px;
    }
    .footer-link li {
        padding: 0 14px;
    }
    .footer-link li::before {
        display: block;
        height: 10px;
    }
    .footer-link li a {
        font-size: 1.4rem;
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
.footer-info {
    font-size: 1.2rem;
    margin: -2px -6px;
    overflow: auto;
}
.footer-info::after {
    content: "";
    clear: both;
    display: table;
}
.footer-info li {
    float: left;
    display: inline-block;
    padding: 2px 6px;
}
.footer-info li > span {
    margin-right: 4px;
    color: #fff;
}
.footer-info__tit {
    font-weight: 500;
    color: #fff;
    margin-bottom: 2px;
}
@media (min-width: 576px) {
    .footer-info {
        font-size: 1.4rem;
    }
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
.copyright {
    font-size: 1.2rem;
    color: #959595;
}
.familysite {
    width: 200px;
    font-size: 1.4rem;
    border: 1px solid #fff;
    border-radius: 0;
}
.familysite .v-input__slot {
    height: 36px !important;
}
.familysite .v-text-field--outlined legend {
    border: none;
}
.v-application .familysite,
.familysite input::placeholder,
.familysite .v-select__selection--comma,
.familysite .mdi:before {
    color: #fff !important;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .copyright {
        font-size: 1.4rem;
    }
    .familysite .v-input__slot {
        height: 44px !important;
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
